import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, logInWithEmailAndPassword } from "../firebase";

import "../css/Login.css";
import Banner from "../components/Header-Loged";
import { useGlobalLoadingEffect } from "../components/GlobalLoadingProvider";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, authLoading] = useAuthState(auth);
  const navigate = useNavigate();

  useGlobalLoadingEffect(authLoading);

  useEffect(() => {
    if (!authLoading && user) {
      navigate("/report", { replace: true });
    }
  }, [authLoading, user, navigate]);

  return (
    <div>
      <div className="banner__container">
        <Banner />
      </div>
      <div className="admin__title__card">
        <h2 className="admin__title">Nuevo sistema de reportes</h2>
      </div>
      <div className="login">
        <div className="login__container">
          {!user && !authLoading && (
            <div className="login__form">
              <input
                type="email"
                className="login__textBox"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="E-mail Address"
                autoComplete="email"
              />
              <input
                type="password"
                className="login__textBox"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Password"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login__btn"
                onClick={() => logInWithEmailAndPassword(email.trim(), password)}
              >
                Ingresar
              </button>
              <div>
                <Link to="/reset">
                  <button type="button" className="login__btn">
                    Olvidé mi contraseña
                  </button>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
